import { render, staticRenderFns } from "./ImportDiscount.vue?vue&type=template&id=3304f132"
import script from "./ImportDiscount.vue?vue&type=script&lang=ts"
export * from "./ImportDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports